export default __webpack_public_path__ + "static/media/bg-sm.a539a884.png";